/* Convenience validation only; trusted consent recording is a separate integration. */
(function () {
  var form = document.getElementById('gadgetrest-support-form');
  if (!form) return;
  var consent = document.getElementById('gr-sms-consent');
  var phone = document.getElementById('gr-phone');
  if (!consent || !phone) return;
  function updatePhone() {
    phone.required = consent.checked;
    phone.setCustomValidity('');
    if (consent.checked && !phone.value.trim()) phone.setCustomValidity('Please enter your mobile number to request text replies.');
  }
  consent.addEventListener('change', updatePhone);
  phone.addEventListener('input', updatePhone);
  form.addEventListener('submit', updatePhone);
  updatePhone();
})();
